var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-footer',{staticClass:"el-footer",staticStyle:{"padding-left":"0"},attrs:{"height":"4rem"}},[_vm._v("2021 Created by 北京瀚禹信息科技有限公司")])}
var staticRenderFns = []

export { render, staticRenderFns }